module.exports = __webpack_public_path__ + "static/media/ST 7.50e42b85.jpg";